export const MiniCartBuilderComponent = {
  name: '_MiniCart_',
  inputs: [
    {
      name: 'checkoutLinkOverride',
      friendlyName: 'Checkout Link Override',
      type: 'string',
      defaultValue: null,
      helperText:
        'Overrides the default checkout link. Primary use case is to bypass the checkout interstitial upsell page. Only use this if you 100% know what you are doing because you could prevent users from accessing checkout.',
    },
  ],
} as const;

export default MiniCartBuilderComponent;
